import { useEffect, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { Button } from "@headlessui/react";
import Select from "../../components/input/Select";
import { handleEnterKey } from "../../app/keyboardUtils";
import { useAddUserToSchoolMutation, useGetAvailableSchoolAdminsQuery } from "./schoolsApiSlice";

interface Props {
	schoolId?: number;
	onClose: () => void;
	onSwitchToNewTab?: () => void;
}

export default function AddExistingSchoolAdminForm(props: Props) {
	const [selectedAdmin, setSelectedAdmin] = useState("");

	const availableAdminsResult = useGetAvailableSchoolAdminsQuery(props.schoolId ?? skipToken);
	const availableAdmins = availableAdminsResult.data;

	const [addToSchool] = useAddUserToSchoolMutation();

	useEffect(() => {
		if (availableAdmins && availableAdmins?.length > 0) {
			setSelectedAdmin(availableAdmins[0].value.toString());
		} else if (availableAdmins && availableAdmins.length === 0 && props.onSwitchToNewTab) {
			props.onSwitchToNewTab();
		}
	}, [availableAdmins, props.onSwitchToNewTab]);

	function handleAddAdmin() {
		if (props.schoolId && selectedAdmin) {
			addToSchool({ schoolId: props.schoolId, userId: Number(selectedAdmin) })
				.unwrap()
				.then(() => {
					props.onClose();
				});
		}
	}

	function handleCancel() {
		props.onClose();
	}

	return (
		<section>
			{availableAdmins && availableAdmins.length > 0 ? (
				<Select
					value={selectedAdmin}
					setValue={(v) => setSelectedAdmin(v as string)}
					simpleListBoxId="adminDropdown"
					options={availableAdmins}
					label="Name:"
					fieldClasses="pt-3"
					simpleListBoxClasses="w-full"
				/>
			) : (
				<div className="mt-4 px-4 py-4 bg-gray-50 border border-gray-200 rounded-lg">
					<p className="text-gray-700 text-center">
						There are no school administrators available in the district to add to the
						school.
					</p>
				</div>
			)}
			<div className="mt-6 grid grid-cols-2 gap-3">
				<Button
					id="cancel-button"
					onClick={handleCancel}
					onKeyDown={(e) => handleEnterKey(e, handleCancel)}
					className="btn btn-neutral">
					Cancel
				</Button>
				<Button
					id="confirm-button"
					disabled={!selectedAdmin}
					onClick={handleAddAdmin}
					onKeyDown={(e) => handleEnterKey(e, handleAddAdmin)}
					className="btn btn-primary">
					Add School Administrator
				</Button>
			</div>
		</section>
	);
}
